document.addEventListener('DOMContentLoaded', function() {
  const popupButton = document.querySelector('.popup__button');
  const popup = document.querySelector('.popup');
  const popupClose = document.querySelector('.popup__close');

 if (popupButton) {
    popupButton.addEventListener('click', function(event) {
      event.preventDefault();  
      popup.classList.add('active');
    });

    popupClose.addEventListener('click', function() {
      popup.classList.remove('active');
    });
  }
});